/* UNE LECTURE LANCÉE DEUX FOIS PAR DEUX ÉCRANS MONTÉS ENSEMBLE NE PART QU'UNE FOIS (2026-10-22). Tant qu'une requête
   identique est en vol, un second appel reprend la même réponse (copiée, pour que l'un ne modifie pas la donnée de
   l'autre) ; dès qu'elle revient, la clé est libérée : jamais de donnée périmée après une écriture. */
const enVol = new Map();
export function partage(cle, lancer) {
  if (!enVol.has(cle)) {
    const p = lancer().finally(() => enVol.delete(cle));
    enVol.set(cle, p);
  }
  return enVol.get(cle).then((r) => (typeof structuredClone === 'function' ? structuredClone(r) : JSON.parse(JSON.stringify(r))));
}
